import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Produit } from "../../core/model/produit";
import { ProduitService } from "../../core/service/produit.service";

@Component({
  selector: "app-edit-produit",
  templateUrl: "./edit-produit.component.html",
  styleUrls: ["./edit-produit.component.scss"],
})
export class EditProduitComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  produitId: number;
  produit: Produit;

  constructor(
    private _router: Router,
    private _produitService: ProduitService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.produitId = params["produitId"];
      this.getProduit(this.produitId);
    });
  }

  getProduit(produitId) {
    this._produitService.getProduitById(produitId).subscribe(
      (data) => {
        this.produit = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this._produitService
      .update(this.produit)
      .pipe(first())
      .subscribe(
        (data) => {
          this._router.navigateByUrl(
            "/parametrage/produit/" + this.produit.typeCredit.id
          );
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this._router.navigate([
      "/parametrage/produit/" + this.produit.typeCredit.id,
    ]);
  }
}
